










import Vue, { PropOptions } from 'vue';

type AboutPage = Blok & {
  sections: Blok[];
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<AboutPage>,
  },
});
